import { render, staticRenderFns } from "./SampleSetsTable.vue?vue&type=template&id=0d7f70ee"
import script from "./SampleSetsTable.vue?vue&type=script&lang=js"
export * from "./SampleSetsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports